import { createI18n } from 'vue-i18n';
import en from './locales/en_US.json';
import de from './locales/de_DE.json';

const SUPPORTED = ['en', 'de'];

function detectLocale() {
    const saved = localStorage.getItem('locale');
    if (saved && SUPPORTED.includes(saved)) return saved;
    const nav = (navigator.language || 'en').toLowerCase();
    return nav.startsWith('de') ? 'de' : 'en';
}

export const i18n = createI18n({
    legacy: false,
    locale: detectLocale(),
    fallbackLocale: 'en',
    messages: { en, de }
});

export function setLocale(locale) {
    if (!SUPPORTED.includes(locale)) return;
    i18n.global.locale.value = locale;
    localStorage.setItem('locale', locale);
    // reflect in <html lang="...">
    if (typeof document !== 'undefined') {
        document.documentElement.setAttribute('lang', locale);
    }
}

export function getLocale() {
    return i18n.global.locale.value;
}
